export const countryId={
    Bahrain:1,
    Kuwait:2,
    Nepal:3,
    Oman:4,
    Qatar:5,
    UAE:6,
    SaudiArabia:7,
    India : 8

}